import React, { useLayoutEffect, useRef, useState } from "react";

export function PlatformPreview({ html }: { html: string }) {
  const container = useRef<HTMLDivElement>(null);
  const [viewport, setViewport] = useState({ width: window.innerWidth, scale: 1 });
  useLayoutEffect(() => {
    const measure = () => {
      const width = window.innerWidth;
      const available = container.current?.clientWidth || width;
      setViewport({ width, scale: Math.min(1, available / width) });
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(container.current!);
    window.addEventListener("resize", measure);
    return () => { observer.disconnect(); window.removeEventListener("resize", measure); };
  }, []);
  return <div ref={container} className="platform-preview-viewport" style={{ height: 1000 * viewport.scale }}><iframe className="platform-preview" title="原站文章预览" srcDoc={html} style={{ width: viewport.width, transform: `scale(${viewport.scale})` }} sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"/></div>;
}
